import React, { Fragment } from 'react';
import { Switch } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';

import Auftragserfassung from '../../layouts/tms/auftragserfassung/Auftragserfassung';
import Auftragsresearch from '../../layouts/tms/auftragsresearch/Auftragsresearch';
import Usermanagement from '../../layouts/tms/usermanagement/Usermanagement';
import Disposition from '../../layouts/tms/disposition/Disposition';
import Accounting from '../../layouts/tms/accounting/Accounting';
import ColorClassPicker from '../../layouts/dev/color-class-picker/ColorClassPicker';
import Adressmanagement from '../../layouts/tms/adressmanagement/Adressmanagement';
import Adresserfassung from '../../layouts/tms/adresserfassung/Adresserfassung';
import { connect } from 'react-redux';
import Registrierung from '../../layouts/register/Registrierung';
import PublicRoute from './PublicRoute';
import Login from '../../layouts/login/Login';
import Adminbereich from '../../layouts/tms/admin/Adminbereich';
import AuftragsvorlageManagement from '../../layouts/tms/auftragsvorlage/management/AuftragsvorlageManagement';
import ForgottenPassword from '../../layouts/login/ForgottenPassword';
import Offeneauftraege from '../../layouts/tms/auftragsresearch/Offeneauftraege';
import Auftragsexport from '../../layouts/tms/auftragsresearch/Auftragsexport';
import ComfortableConfigurator from '../../layouts/tms/admin/ComfortableConfigurator';

export const INITIAL_LAYOUT = '/auftragsmanagement/auftragsresearch';

export const Routes = () => {
  return (
    <Fragment>
      <Switch>
        <PublicRoute exact path='/' layout={Login} />
        <PublicRoute path='/login' layout={Login} />
        <PublicRoute path='/index' layout={Login} />
        <PublicRoute path='/forgottenPassword' layout={ForgottenPassword} />
        <PublicRoute path='/confirmreg' layout={Login} />
        <PublicRoute exact path='/register' layout={Registrierung} />

        <PrivateRoute
          path='/auftragsmanagement/auftragserfassung'
          layout={Auftragserfassung}
        />
        <PrivateRoute
          exact
          path='/auftragsmanagement/auftragsresearch'
          layout={Auftragsresearch}
        />
        <PrivateRoute
          exact
          path='/auftragsmanagement/offeneauftraege'
          layout={Offeneauftraege}
        />
        <PrivateRoute
          exact
          path='/auftragsmanagement/auftragsvorlagen'
          layout={AuftragsvorlageManagement}
        />
        <PrivateRoute
          exact
          path='/auftragsmanagement/auftragsexport'
          layout={Auftragsexport}
        />
        <PrivateRoute
          exact
          path='/masterdata/adressmanagement'
          layout={Adressmanagement}
        />
        <PrivateRoute
          path='/masterdata/adresserfassung'
          layout={Adresserfassung}
        />
        <PrivateRoute
          exact
          path='/masterdata/usermanagement'
          layout={Usermanagement}
        />
        <PrivateRoute
          exact
          path='/admin/coco'
          layout={ComfortableConfigurator}
        />
        <PrivateRoute exact path='/admin' layout={Adminbereich} />
        <PrivateRoute exact path='/disposition' layout={Disposition} />
        <PrivateRoute exact path='/accounting' layout={Accounting} />
        <PrivateRoute exact path='/farben' layout={ColorClassPicker} />
      </Switch>
    </Fragment>
  );
};

export default connect(null, {})(Routes);
